import { render } from "./CustomInputUrl.vue?vue&type=template&id=4a76ad04"
import script from "./CustomInputUrl.vue?vue&type=script&lang=js"
export * from "./CustomInputUrl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__